import React from 'react';

function resolveChipColor(color) {
  if (!color || color === 'primary') return '#00f3ff';
  if (color === 'secondary') return '#00ff41';
  return color;
}

export function CareerItem({ career, isOpen, onToggle }) {
  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        className="mb-2.5 flex w-full cursor-pointer items-center rounded-lg border border-[#00f3ff]/[0.18] bg-[#142542]/[0.62] px-4 py-2 text-left transition-all duration-200 hover:border-[#00f3ff]/40 hover:bg-[#00f3ff]/[0.08]"
      >
        <span className="flex min-w-[56px] shrink-0 items-center">
          <svg
            className="h-6 w-6 fill-current text-[#00f3ff]"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z" />
          </svg>
        </span>
        <div className="my-1.5 min-w-0 flex-1">
          <div className="text-base leading-normal text-[#e8effd]">
            <span className="font-extrabold">{career.name}</span>
            <span className="mx-2">·</span>
            <span>{career.date}</span>
          </div>
          <div className="text-sm leading-[1.43] text-[#a4b4d2]">
            {career.title}
          </div>
        </div>
        {isOpen ? (
          <svg
            className="h-6 w-6 shrink-0 fill-current text-[#e8effd]"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z" />
          </svg>
        ) : (
          <svg
            className="h-6 w-6 shrink-0 fill-current text-[#e8effd]"
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z" />
          </svg>
        )}
      </button>
      {isOpen && (
        <div>
          <p className="mb-1.5 break-words pl-2 font-mono text-base text-[#00f3ff] sm:pl-[72px]">
            <b>{career.title}</b>
          </p>
          {career.description &&
            (Array.isArray(career.description) ? (
              <ul className="mb-3.5 list-disc space-y-1.5 break-words pl-7 text-base leading-relaxed text-[#e8effd] marker:text-[#00f3ff] sm:pl-[92px]">
                {career.description.map((bullet, idx) => (
                  <li key={idx}>{bullet}</li>
                ))}
              </ul>
            ) : (
              <p className="mb-3.5 break-words pl-2 text-base leading-relaxed text-[#e8effd] sm:pl-[72px]">
                {career.description}
              </p>
            ))}
          <div className="flex flex-wrap pb-8 pl-2 sm:pl-16">
            {career.tags.map((e) => {
              const chipColor = resolveChipColor(e.color);
              return (
                <span
                  key={e.name}
                  style={{ color: chipColor, borderColor: chipColor }}
                  className="mr-2 mt-2 inline-flex h-8 items-center justify-center rounded-full border px-3 font-mono text-[0.8125rem] transition-all duration-200 hover:-translate-y-px hover:bg-[#00f3ff]/[0.06] hover:shadow-[0_0_10px_rgba(0,243,255,0.25)]"
                >
                  {e.name}
                </span>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
